// extracted by mini-css-extract-plugin
export default {"fine-print":"Footer_fine-print__0Njio","footer":"Footer_footer__EwVYi","huluwa":"Footer_huluwa__aL1mT"};